import * as R from '../Router/routes';
import { Client } from '../hooks/webapi/useClient';
import { MenuItem } from '../components/MobileMenu/MobileMenu';
import { userIsNotIdentified } from './userIsNotIdentified';

export const getMenuItems = (
  menuItems: MenuItem[],
  client: Client | undefined | null,
) => {
  const userNotIdentified = userIsNotIdentified(client);
  if (!userNotIdentified) return menuItems;

  // Disable Dashboard screen
  return menuItems.map((item) =>
    item.url === R.ACTIVE_LOAN || item.url === R.REPEATED_LOAN
      ? { ...item, disabled: true }
      : item,
  );
};
